<template>
  <div class="ordem-detalhes-card">
    <!-- Header com Navegação -->
    <div class="detalhes-header">
      <button @click="$emit('voltar')" class="btn-voltar">
        ← Voltar para Lista
      </button>
      <div class="header-actions">
        <button @click="abrirCoracaoOriginal" class="btn-completo">
          🔍 Análise Completa (Coração)
        </button>
        <button @click="imprimirDetalhes" class="btn-imprimir">
          🖨️ Imprimir
        </button>
      </div>
    </div>

    <!-- Título da Ordem -->
    <div class="ordem-titulo-secao">
      <h2>Ordem #{{ ordem.id_ordem || ordem.id }} - {{ ordem.cliente }}</h2>
      <span class="status-badge-grande" :class="ordem.status">
        {{ formatarStatus(ordem.status) }}
      </span>
    </div>

    <!-- Badges de Alerta -->
    <div class="alertas-container" v-if="temAlertas">
      <div v-if="ordem.atrasada" class="alerta atrasada">
        🚨 <strong>ORDEM ATRASADA</strong> - Requer atenção imediata!
      </div>
      <div v-if="ordem.urgente" class="alerta urgente">
        ⚡ <strong>ORDEM URGENTE</strong> - Prazo próximo do vencimento
      </div>
      <div v-if="ordem.critica" class="alerta critica">
        🔥 <strong>ORDEM CRÍTICA</strong> - Alta prioridade para produção
      </div>
    </div>

    <!-- Grid de Informações Principais -->
    <div class="detalhes-grid">
      <!-- Informações Básicas -->
      <div class="detalhe-secao">
        <h3>📋 Informações Básicas</h3>
        <div class="detalhe-items">
          <div class="detalhe-item">
            <span class="label">📦 Produto:</span>
            <span class="valor destaque">{{ obterNomeProduto(ordem) }}</span>
          </div>
          <div class="detalhe-item">
            <span class="label">👤 Cliente:</span>
            <span class="valor">{{ ordem.cliente || 'Não informado' }}</span>
          </div>
          <div class="detalhe-item">
            <span class="label">📅 Data de Criação:</span>
            <span class="valor">{{ formatarData(ordem.data_lancamento) }}</span>
          </div>
          <div class="detalhe-item">
            <span class="label">📅 Prazo de Entrega:</span>
            <span class="valor" :class="{ 'prazo-proximo': isPrazoProximo(ordem) }">
              {{ formatarData(ordem.prazo_entrega) }}
            </span>
          </div>
          <div class="detalhe-item">
            <span class="label">🔢 Prioridade:</span>
            <span class="valor prioridade" :class="getClassePrioridade(ordem.prioridade)">
              {{ ordem.prioridade || 'Não definida' }}
            </span>
          </div>
        </div>
      </div>

      <!-- Produção Pecas -->
      <div class="detalhe-secao">
        
        
        
        <h3>🏭 Produção Peças</h3>
        <div class="detalhe-items">
          <div class="detalhe-item">
            <span class="label">📊 Quantidade Total:</span>
            <span class="valor destaque">{{ ordem.quantidade_total || 0 }}</span>
          </div>
          <div class="detalhe-item">
            <span class="label">✅ Quantidade Produzida:</span>
            <span class="valor sucesso">{{ ordem.quantidade_produzida || 0 }}</span>
          </div>
          <div class="detalhe-item">
            <span class="label">⏳ Quantidade Restante:</span>
            <span class="valor">{{ ordem.quantidade_total - ordem.quantidade_produzida }}</span>
          </div>
        </div>
      </div>


      
      <!-- Produção Processos -->
      <div class="detalhe-secao">
        
        
        
        <h3>🏭 Produção Processos</h3>
        <div class="detalhe-items">
          <div class="detalhe-item">
            <span class="label">📊 Quantidade Total:</span>
            <span class="valor destaque">{{ ordem.quantidade_total_processos || 0 }}</span>
          </div>
          <div class="detalhe-item">
            <span class="label">✅ Quantidade Produzida:</span>
            <span class="valor sucesso">{{ ordem.quantidade_total_processos_concluidos || 0 }}</span>
          </div>
          <div class="detalhe-item">
            <span class="label">⏳ Quantidade Restante:</span>
            <span class="valor">{{ ordem.quantidade_total_processos - ordem.quantidade_total_processos_concluidos }}</span>
          </div>
        </div>
      </div>

      <!-- Progresso Visual -->
      <div class="detalhe-secao">
        <h3>📈 Progresso Atual</h3>
        <div class="progresso-visual">
          <div class="progresso-circular">
            <svg class="progresso-svg" viewBox="0 0 120 120">
              <circle cx="60" cy="60" r="50" fill="none" stroke="#ecf0f1" stroke-width="8" />
              <circle cx="60" cy="60" r="50" fill="none" :stroke="getCorProgresso(progresso)" stroke-width="8"
                stroke-linecap="round" :stroke-dasharray="circumferencia" :stroke-dashoffset="offsetProgresso"
                transform="rotate(-90 60 60)" class="progresso-circle" />
            </svg>
            <div class="progresso-texto">
              <span class="progresso-numero">{{ progresso }}%</span>
              <span class="progresso-label">Concluído</span>
            </div>
          </div>

          <div class="progresso-detalhes">
            <div class="progresso-item">
              <span class="progresso-dot concluido"></span>
              <span>{{ ordem.quantidade_total_processos || 0 }} Processos</span>
            </div>
            <div class="progresso-item">
              <span class="progresso-dot pendente"></span>
              <span>{{ ordem.quantidade_total_processos_concluidos }} Processos Concluídos</span>
            </div>
            <div class="progresso-item">
              <span class="progresso-dot tempo"></span>
              <span>{{ ordem.quantidade_total_processos - ordem.quantidade_total_processos_concluidos }} Processos
                Falta</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Tempos e Prazos -->
      <div class="detalhe-secao">
        <h3>⏰ Tempos e Prazos</h3>
        <div class="detalhe-items">
          <div class="detalhe-item">
            <span class="label">⏱️ Tempo Estimado:</span>
            <span class="valor">{{ formatarTempoEstimado(ordem.tempo_estimado) }}</span>
          </div>
          <div class="detalhe-item">
            <span class="label">⏳ Tempo Trabalhado:</span>
            <span class="valor">{{ ordem.tempo_trabalhado || 0 }}h</span>
          </div>
          <div class="detalhe-item">
            <span class="label">📅 Dias Restantes:</span>
            <span class="valor" :class="getClasseDiasRestantes(diasRestantes)">
              {{ diasRestantes }} dias
            </span>
          </div>
          <div class="detalhe-item">
            <span class="label">📊 Eficiência:</span>
            <span class="valor">{{ calcularEficiencia() }}%</span>
          </div>
        </div>
      </div>

      <!-- Observações -->
      <div class="detalhe-secao observacoes-secao" v-if="ordem.observacoes">
        <h3>📝 Observações</h3>
        <div class="observacoes-conteudo">
          <p>{{ ordem.observacoes }}</p>
        </div>
      </div>

      <!-- Histórico Resumido -->
      <div class="detalhe-secao historico-secao">
        <h3>📚 Histórico Recente</h3>
        <div class="historico-items">
          <div class="historico-item">
            <span class="historico-data">{{ formatarData(ordem.prazo_entrega) }}</span>
            <span class="historico-acao">Prazo de entrega</span>
          </div>
          <div class="historico-item" v-if="ordem.data_inicio">
            <span class="historico-data">{{ formatarData(ordem.data_inicio) }}</span>
            <span class="historico-acao">Produção iniciada</span>
          </div>
          <div class="historico-item" v-if="ordem.ultima_atualizacao">
            <span class="historico-data">{{ formatarData(ordem.ultima_atualizacao) }}</span>
            <span class="historico-acao">Última atualização</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Ações Rápidas -->
    <div class="acoes-rapidas">
      <h3>⚡ Ações Rápidas</h3>
      <div class="acoes-grid">
        <button class="acao-btn editar" @click="editarOrdem">
          ✏️ Editar Ordem
        </button>
        <button class="acao-btn atualizar" @click="atualizarProgresso">
          📊 Atualizar Progresso
        </button>
        <button class="acao-btn priorizar" @click="alterarPrioridade">
          🔝 Alterar Prioridade
        </button>
        <button class="acao-btn comentar" @click="adicionarComentario">
          💬 Adicionar Comentário
        </button>
        <button class="acao-btn imprimir" @click="gerarRelatorio">
          📄 Gerar Relatório
        </button>
        <button class="acao-btn historico" @click="verHistoricoCompleto">
          📚 Histórico Completo
        </button>
      </div>
    </div>  
  </div>

     <VisualizarProducaoOrdem v-model="dialogProducao" :id-ordem="ordem.id" :setorAtualRecebidoPai="setorSelecionado?setorSelecionado:null" />


</template>

<script>

import VisualizarProducaoOrdem from "@/components/VisualizarProducaoOrdem.vue";

export default {
  components: {
    VisualizarProducaoOrdem 
  },
  name: 'OrdemDetalhesCard',

  props: {
    ordem: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dialogProducao: false,
      ordemCompletaId: null,
      setorSelecionado: null,
    };
  },

  emits: ['voltar', 'abrir-completo'],

  computed: {
    progresso() {
      if (!this.ordem.quantidade_total_processos || this.ordem.quantidade_total_processos === 0) return 0;
      const produzida = this.ordem.quantidade_total_processos_concluidos || 0;
      return Math.round((produzida / this.ordem.quantidade_total_processos) * 100);
    },

    quantidadeRestante() {
      const total = this.ordem.quantidade_total_processos || 0;
      const produzida = this.ordem.quantidade_total_processos_concluidos || 0;
      return Math.max(0, total - produzida);
    },

    diasRestantes() {
      if (!this.ordem.prazo_entrega_formatado) return 'N/A';

      try {
        const prazo = new Date(this.ordem.prazo_entrega_formatado);
        const hoje = new Date();
        const diff = Math.ceil((prazo - hoje) / (1000 * 60 * 60 * 24));
        return diff;
      } catch (error) {
        return 'N/A';
      }
    },

    temAlertas() {
      return this.ordem.atrasada || this.ordem.urgente || this.ordem.critica;
    },

    circumferencia() {
      return 2 * Math.PI * 50; // raio = 50
    },

    offsetProgresso() {
      return this.circumferencia - (this.progresso / 100) * this.circumferencia;
    }
  },

  methods: {
    abrirCoracaoOriginal() {
      this.dialogProducao = true;
    },
    formatarTempoEstimado(tempoObj) {
      if (!tempoObj) return 'Não definido';

      // Se é um objeto com a estrutura da API
      if (typeof tempoObj === 'object' && tempoObj.formatado) {
        return tempoObj.formatado + 'h';
      }

      // Se é um número simples
      if (typeof tempoObj === 'number') {
        return tempoObj + 'h';
      }

      // Se é string
      if (typeof tempoObj === 'string') {
        return tempoObj + (tempoObj.includes('h') ? '' : 'h');
      }

      return 'Não definido';
    },

    obterNomeProduto(ordem) {
      if (ordem.produto && ordem.produto !== 'não informado' && ordem.produto.trim() !== '') {
        return ordem.produto;
      }

      if (ordem.nome_produto && ordem.nome_produto !== 'não informado' && ordem.nome_produto.trim() !== '') {
        return ordem.nome_produto;
      }

      if (ordem.descricao_produto && ordem.descricao_produto !== 'não informado' && ordem.descricao_produto.trim() !== '') {
        return ordem.descricao_produto;
      }

      if (ordem.item && ordem.item !== 'não informado' && ordem.item.trim() !== '') {
        return ordem.item;
      }

      return `Produto da Ordem #${ordem.id_ordem || ordem.id}`;
    },

    formatarStatus(status) {
      const statusMap = {
        'pendente': 'Pendente',
        'em_andamento': 'Em Andamento',
        'concluida': 'Concluída',
        'cancelada': 'Cancelada'
      };
      return statusMap[status] || status;
    },

    formatarData(data) {
      if (!data) return 'Não definido';

      if (typeof data === 'string' && data.includes('/')) {
        return data;
      }

      try {
        return new Date(data).toLocaleDateString('pt-BR');
      } catch (error) {
        return 'Data inválida';
      }
    },

    isPrazoProximo(ordem) {
      if (!ordem.prazo_entrega_formatado) return false;

      try {
        const prazo = new Date(ordem.prazo_entrega_formatado);
        const hoje = new Date();
        const diasRestantes = Math.ceil((prazo - hoje) / (1000 * 60 * 60 * 24));

        return diasRestantes <= 7 && diasRestantes > 0;
      } catch (error) {
        return false;
      }
    },

    getClassePrioridade(prioridade) {
      if (!prioridade) return '';
      if (prioridade <= 3) return 'alta';
      if (prioridade <= 6) return 'media';
      return 'baixa';
    },

    getClasseDiasRestantes(dias) {
      if (dias === 'N/A') return '';
      if (dias < 0) return 'atrasado';
      if (dias <= 3) return 'urgente';
      if (dias <= 7) return 'proximo';
      return 'normal';
    },

    getCorProgresso(percentual) {
      if (percentual >= 80) return '#27ae60';
      if (percentual >= 50) return '#3498db';
      if (percentual >= 20) return '#f39c12';
      return '#e74c3c';
    },

    calcularEficiencia() {
      // Os dados vêm como objeto: { minutos: 15500, horas: 258.33, formatado: "258:20" }
      const tempoEstimadoObj = this.ordem.tempo_estimado;
      const tempoEstimadoHoras = tempoEstimadoObj?.horas || 0;
      const tempoTrabalhado = this.ordem.tempo_trabalhado || 0;

      if (tempoEstimadoHoras === 0 || tempoTrabalhado === 0) return 0;

      const eficiencia = (this.progresso / (tempoTrabalhado / tempoEstimadoHoras * 100)) * 100;
      return Math.round(Math.min(eficiencia, 999));
    },

    // Ações
    editarOrdem() {
      console.log('Editar ordem:', this.ordem.id);
      // Implementar navegação para edição
    },

    atualizarProgresso() {
      console.log('Atualizar progresso da ordem:', this.ordem.id);
      // Implementar modal de atualização
    },

    alterarPrioridade() {
      console.log('Alterar prioridade da ordem:', this.ordem.id);
      // Implementar modal de prioridade
    },

    adicionarComentario() {
      console.log('Adicionar comentário à ordem:', this.ordem.id);
      // Implementar modal de comentário
    },

    gerarRelatorio() {
      console.log('Gerar relatório da ordem:', this.ordem.id);
      // Implementar geração de relatório
    },

    verHistoricoCompleto() {
      console.log('Ver histórico completo da ordem:', this.ordem.id);
      // Implementar modal de histórico
    },

    imprimirDetalhes() {
      window.print();
    }
  }
}
</script>

<style scoped>
.ordem-detalhes-card {
  background: white;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* Header */
.detalhes-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
  padding-bottom: 15px;
  border-bottom: 2px solid #ecf0f1;
}

.btn-voltar {
  padding: 10px 20px;
  background: #ecf0f1;
  color: #7f8c8d;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.3s ease;
}

.btn-voltar:hover {
  background: #d5dbdb;
  transform: translateX(-3px);
}

.header-actions {
  display: flex;
  gap: 12px;
}

.btn-completo,
.btn-imprimir {
  padding: 10px 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.3s ease;
}

.btn-completo {
  background: #3498db;
  color: white;
}

.btn-completo:hover {
  background: #2980b9;
  transform: translateY(-2px);
}

.btn-imprimir {
  background: #95a5a6;
  color: white;
}

.btn-imprimir:hover {
  background: #7f8c8d;
}

/* Título */
.ordem-titulo-secao {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
}

.ordem-titulo-secao h2 {
  margin: 0;
  color: #2c3e50;
  font-size: 24px;
}

.status-badge-grande {
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: bold;
  text-transform: uppercase;
}

.status-badge-grande.pendente {
  background: #fff3e0;
  color: #f57c00;
}

.status-badge-grande.em_andamento {
  background: #e3f2fd;
  color: #1976d2;
}

.status-badge-grande.concluida {
  background: #e8f5e8;
  color: #2e7d32;
}

.status-badge-grande.cancelada {
  background: #ffebee;
  color: #d32f2f;
}

/* Alertas */
.alertas-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 25px;
}

.alerta {
  padding: 12px 16px;
  border-radius: 8px;
  font-weight: 500;
  border-left: 4px solid;
}

.alerta.atrasada {
  background: #ffebee;
  color: #c62828;
  border-color: #e74c3c;
}

.alerta.urgente {
  background: #fff3e0;
  color: #ef6c00;
  border-color: #f39c12;
}

.alerta.critica {
  background: #f3e5f5;
  color: #7b1fa2;
  border-color: #8e44ad;
}

/* Grid de Detalhes */
.detalhes-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 25px;
  margin-bottom: 30px;
}

.detalhe-secao {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  border-left: 4px solid #3498db;
}

.detalhe-secao h3 {
  margin: 0 0 15px 0;
  color: #2c3e50;
  font-size: 16px;
}

.detalhe-items {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.detalhe-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #ecf0f1;
}

.detalhe-item:last-child {
  border-bottom: none;
}

.label {
  font-size: 14px;
  color: #7f8c8d;
  font-weight: 500;
}

.valor {
  color: #2c3e50;
  font-weight: 500;
  text-align: right;
}

.valor.destaque {
  color: #3498db;
  font-weight: bold;
}

.valor.sucesso {
  color: #27ae60;
  font-weight: bold;
}

.prazo-proximo {
  color: #f39c12 !important;
  font-weight: bold;
}

.prioridade.alta {
  color: #e74c3c;
}

.prioridade.media {
  color: #f39c12;
}

.prioridade.baixa {
  color: #27ae60;
}

.atrasado {
  color: #e74c3c;
  font-weight: bold;
}

.urgente {
  color: #f39c12;
  font-weight: bold;
}

.proximo {
  color: #f39c12;
}

.normal {
  color: #27ae60;
}

/* Progresso Visual */
.progresso-secao {
  grid-column: span 2;
}

.progresso-visual {
  display: flex;
  align-items: center;
  gap: 30px;
}

.progresso-circular {
  position: relative;
  width: 120px;
  height: 120px;
}

.progresso-svg {
  width: 100%;
  height: 100%;
  transform: rotate(-90deg);
}

.progresso-circle {
  transition: stroke-dashoffset 0.5s ease;
}

.progresso-texto {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.progresso-numero {
  display: block;
  font-size: 24px;
  font-weight: bold;
  color: #2c3e50;
}

.progresso-label {
  display: block;
  font-size: 12px;
  color: #7f8c8d;
}

.progresso-detalhes {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.progresso-item {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: #2c3e50;
}

.progresso-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}

.progresso-dot.concluido {
  background: #27ae60;
}

.progresso-dot.pendente {
  background: #f39c12;
}

.progresso-dot.tempo {
  background: #3498db;
}

/* Observações */
.observacoes-secao {
  grid-column: span 2;
}

.observacoes-conteudo {
  background: white;
  padding: 15px;
  border-radius: 6px;
  border: 1px solid #ecf0f1;
}

.observacoes-conteudo p {
  margin: 0;
  color: #2c3e50;
  line-height: 1.6;
}

/* Histórico */
.historico-items {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.historico-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: white;
  border-radius: 6px;
  border-left: 3px solid #3498db;
}

.historico-data {
  font-size: 12px;
  color: #7f8c8d;
}

.historico-acao {
  font-size: 14px;
  color: #2c3e50;
  font-weight: 500;
}

/* Ações Rápidas */
.acoes-rapidas {
  background: #f8f9fa;
  padding: 25px;
  border-radius: 8px;
  border-left: 4px solid #27ae60;
}

.acoes-rapidas h3 {
  margin: 0 0 20px 0;
  color: #2c3e50;
}

.acoes-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
}

.acao-btn {
  padding: 12px 16px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.3s ease;
  text-align: center;
}

.acao-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.acao-btn.editar {
  background: #3498db;
  color: white;
}

.acao-btn.atualizar {
  background: #27ae60;
  color: white;
}

.acao-btn.priorizar {
  background: #e74c3c;
  color: white;
}

.acao-btn.comentar {
  background: #f39c12;
  color: white;
}

.acao-btn.imprimir {
  background: #95a5a6;
  color: white;
}

.acao-btn.historico {
  background: #8e44ad;
  color: white;
}

/* Responsividade */
@media (max-width: 1200px) {
  .progresso-secao {
    grid-column: span 1;
  }

  .observacoes-secao {
    grid-column: span 1;
  }
}

@media (max-width: 768px) {
  .ordem-detalhes-card {
    padding: 20px;
  }

  .detalhes-header {
    flex-direction: column;
    gap: 15px;
    align-items: flex-start;
  }

  .header-actions {
    align-self: stretch;
  }

  .btn-completo,
  .btn-imprimir {
    flex: 1;
    text-align: center;
  }

  .ordem-titulo-secao {
    flex-direction: column;
    gap: 15px;
    align-items: flex-start;
  }

  .detalhes-grid {
    grid-template-columns: 1fr;
  }

  .progresso-visual {
    flex-direction: column;
    gap: 20px;
    text-align: center;
  }

  .acoes-grid {
    grid-template-columns: 1fr;
  }

  .detalhe-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  .valor {
    text-align: left;
  }
}

@media print {

  .detalhes-header,
  .acoes-rapidas {
    display: none;
  }

  .ordem-detalhes-card {
    box-shadow: none;
    padding: 0;
  }
}
</style>